import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../utils/helpers";
import WAIcon from "./icons/WAIcon";

const Icon = (props) => {
  const {
    className = "text-gray-500",
    icon = "",
    size = 18,
    type = "filled",
  } = props;

  const mapType = {
    filled: "material-icons",
    outlined: "material-symbols-outlined",
    round: "material-icons-round",
    sharp: "material-icons-sharp",
    "two-tone": "material-icons-two-tone",
  };

  if (icon === "Whatsapp") {
    return <WAIcon {...props} />;
  }

  return (
    <>
      <span
        className={classNames(mapType[type], className)}
        style={{
          fontSize: size,
        }}
      >
        {icon ? icon : null}
      </span>
    </>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
};

export default Icon;
